import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ApiService } from '../service/api.service';

@Component({
  selector: 'app-update-password',
  templateUrl: './update-password.component.html',
  styleUrls: ['./update-password.component.css']
})
export class UpdatePasswordComponent implements OnInit {

  isSuccess=false;
  isError=false;
  isSubmitted=false;
  isDisabled=false;
  message:string='';
  inputFormGroup:FormGroup;

  constructor(private formBuilder:FormBuilder,private api:ApiService) {
    this.inputFormGroup=this.formBuilder.group({
      userId:[0],
      old_password:['',Validators.required],
      new_password:['',Validators.required],
      confirm_password:['',Validators.required]
    });

   }

  ngOnInit() {
  }

  saveForm(form)
  {
    this.isError=false;
    this.isSuccess=false;
    this.isDisabled=true;
    this.isSubmitted=true;
    if(this.inputFormGroup.invalid)
    {
      this.isDisabled=false;
      return false;
    }
    else
    {
      form.value.userId=localStorage.getItem('auth_name');
      this.api.post(form.value,'updatePassword').subscribe(data=>{
        if(data.status)
        {
          this.isSuccess=true;
          this.message="Password updated successfully.";
        }
        else
        {
          this.isError=true;
          if(data.errors!=undefined)
          {
            this.message=data.errors.confirm_password;
          }
          else
          {
            this.message=data.message;
          }
          
        }

        this.isSubmitted=false;
        this.isDisabled=false;
        this.inputFormGroup.reset();
      },(error)=>{});

    }
  }

}
